module.exports = __webpack_public_path__ + "img/logo.99b30370.png";